/**
 * Vendor CRUD — backed by /api/vendors.
 */
import { useCrudCollection } from './useCrudCollection';

export function useVendors() {
  const crud = useCrudCollection({ basePath: 'vendors' });
  return {
    vendors: crud.items,
    setVendors: crud.setItems,
    fetchVendors: crud.fetch,
    createVendor: crud.create,
    updateVendor: crud.update,
    deleteVendor: crud.remove,
  };
}
